module.exports = __webpack_public_path__ + "img/logo2____.23d6810c.png";